export default {
  state: {
    trxReport: {
      show: false
    }
  },
  mutations: {
    setShowTrxReport (state, value) { state.trxReport.show = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/reports/reports-trx.js